import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
//#end region
//#region types
import { displayDialog } from "store/actions/utilActions";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Link } from "@mui/material";
import useSupportTicketCreateDialog from "./useCreateDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AddSupportCaseLink: React.FC = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();

  const onCreateSupportCaseClick = () => {
    dispatch(displayDialog(getSupportTicketCreateDialog()));
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onCreateSupportCaseClick();
    }
  };

  // Stays an <a> rather than component="button": every host styles this link through `a` selectors
  // (.formControlDescription a, the snackbar's .danger a), which a <button> would silently lose.
  // Without an href an <a> is neither focusable nor keyboard-activatable, so role, tabIndex and the
  // key handler give it the button behaviour it has in practice (it opens a dialog, not a page).
  return (
    // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- see above
    <Link role="button" tabIndex={0} onClick={onCreateSupportCaseClick} onKeyDown={onKeyDown}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Settings.ContactUs)} {"→"}
    </Link>
  );
};

export default AddSupportCaseLink;
